//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegisterForm from '../../../../shared-components/generico/RegisterForm';
import mdChipsAutocomplete from '../../../../shared-components/chipsautocomplete/mdChipsAutocomplete';
import mdAutocomplete from '../../../../shared-components/autocomplete/mdAutocomplete';

import { copyObject } from '../../../../common/functions/helpers';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'CentroCustoSideColumn',
  props: {
    fetchExtensaoFunction: Function,
    prepareResponseData: Function,
  },
  data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      disableButton: false,
      centroCusto: {
        dependencias: {
          canais: [],
          idsCanal: [],
          idsMarca: [],
          idUnidadeNegocio: '',
          marcas: [],
          unidadeNegocio: {
            id: '',
            nomExtensao: '',
          },
        },
        nome: '',
        indAtivo: true,
        idExterno: '',
        indCliente: false,
        indProduto: false,
      },
      source: [],
    };
  },
  computed: {
    ...generateComputed('Ceco', [
      'canAccessCRUD',
    ]),
  },
  components: {
    RegisterForm,
    mdChipsAutocomplete,
    mdAutocomplete,
  },
  methods: {
    addCanalChip(value) {
      this.centroCusto.dependencias.idsCanal = value.map(el => el.id);
    },
    addMarcaChip(value) {
      this.centroCusto.dependencias.idsMarca = value.map(el => el.id);
    },
    cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm() {
      this.centroCusto = copyObject(this.originalCentroCusto);
      setTimeout(() => {
        this.fields.reset();
        this.errors.clear();
        this.$refs.containerIdExterno.inputLength = 0;
        this.$refs.containerNome.inputLength = 0;
        this.source = [];
      }, 1E2);
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog(ref, from) {
      this.$validator.validateAll()
        .then((isValid) => {
          if (!isValid) {
            return;
          }

          if (this.centroCusto.indCliente === false && this.centroCusto.indProduto === false) {
            this.$toast.create(this.$t('message.erro_salvar_centro_sem_produto_cliente'), 'snack', 5E3);
            return;
          }

          const content = this.$t('message.salvar_novo_centro_custo');
          this.setDialogContent(content, this.save, from || this.dialog.from);

          this.openDialog(ref || this.dialog.ref);
        });
    },
    save(obj) {
      const objCentroCusto = Object.assign({}, obj || this.centroCusto);
      this.$emit('SIDECOLUMN_SAVE_ACTION', objCentroCusto, this.clearForm);
    },
    setUnidadeNegocio(hit) {
      this.centroCusto.dependencias.idUnidadeNegocio = hit.id;
      this.centroCusto.dependencias.unidadeNegocio.id = hit.id;
      this.centroCusto.dependencias.unidadeNegocio.nomExtensao = hit.nomExtensao;
    },
    fetchSuperiorCanalFunction() {
      return (param = null) => {
        const params = Object.assign({}, param,
          { nome: this.$refs.canalAutoComplete.currentChip, idNivelExtensao: 3 });
        return this.fetchExtensaoFunction(params);
      };
    },
    fetchSuperiorMarcaFunction() {
      return (param = null) => {
        const params = Object.assign({}, param,
          { nome: this.$refs.marcaAutoComplete.currentChip, idNivelExtensao: 2 });
        return this.fetchExtensaoFunction(params);
      };
    },
    fetchSuperiorUnidadeNegocioFunction() {
      return (param = null) => {
        const params = Object.assign({}, param,
          { nome: this.centroCusto.dependencias.unidadeNegocio.nomExtensao, idNivelExtensao: 1 });
        return this.fetchExtensaoFunction(params);
      };
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
  },
  mounted() {
    this.originalCentroCusto = copyObject(this.centroCusto);
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/centro-custo/SideColumn.vue?vue&type=script&lang=js&